import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Rajesh Menon",
    role: "Business Owner, Thrissur",
    text: "Adv. Akshay handled my property dispute with exceptional professionalism. His knowledge of Kerala land laws and his strategic approach helped us secure a favourable verdict in the District Court. I would recommend Corpus Juris to anyone looking for reliable legal counsel.",
    rating: 5,
  },
  {
    name: "Priya Krishnan",
    role: "IT Professional, Kochi",
    text: "During a very difficult divorce proceeding, Adv. Akshay provided not only expert legal guidance but also compassionate support. He ensured that my rights were protected throughout and the custody matter was resolved in the best interest of my children. Truly grateful.",
    rating: 5,
  },
  {
    name: "Thomas Varghese",
    role: "Retired Bank Manager, Chavakkad",
    text: "I consulted Corpus Juris for a cheque bounce case under the NI Act. Adv. Akshay's approach was methodical and thorough. He explained every step of the legal process clearly and achieved a successful resolution within a reasonable timeframe. Highly professional.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-28 bg-[#f0e8d8] relative overflow-hidden">
      <div className="absolute top-20 right-10 w-72 h-72 bg-[#b89968]/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-5 px-5 py-2 rounded-full bg-[#b89968]/10 border border-[#b89968]/20">
            <Star className="w-3.5 h-3.5 gold-accent fill-[#b89968]" />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase gold-accent">
              Client Testimonials
            </span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-[#0f1d3a] mb-3">
            What Our Clients <span className="italic font-normal gold-accent">Say</span>
          </h2>
          <div className="section-gold-line mx-auto mb-6" />
          <p className="text-base leading-relaxed text-[#6a7690] max-w-2xl mx-auto">
            Trusted by individuals and businesses across Thrissur and Kerala for delivering
            results-driven legal representation.
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i}`}
              onMouseMove={(e) => {
                const r = e.currentTarget.getBoundingClientRect();
                e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
                e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
              }}
              className="quote-deco spotlight-card tilt-card bg-[#f7f3ea] border border-[#d9cdb4] p-8 rounded-xl hover:shadow-xl hover:shadow-[#b89968]/15 hover:border-[#b89968]/40 transition-all duration-300 group"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#b89968] text-[#b89968]" />
                ))}
              </div>

              {/* Text */}
              <p className="text-sm leading-relaxed text-[#6a7690] mb-8 relative z-10">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="border-t border-[#d9cdb4] pt-5 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-[#0f1d3a] flex items-center justify-center text-[#b89968] font-heading text-lg font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0f1d3a]">{t.name}</p>
                  <p className="text-xs text-[#8892ad] mt-0.5">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
